{
  "LEGACY_API_SECRET_PROJECT_CUTOFF": 4061913,
  "LEGACY_API_SECRET_PROJECT_ALLOWLIST": [4067014, 4067015, 4067024, 4067025, 4067026, 4067027]
}
